module.exports = __webpack_public_path__ + "static/media/github.926af6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/github.svg
// module id = 357
// module chunks = 0